<template>
  <chart-card
    :chart-data="pieChart"
    chart-type="Pie"
    title="RFM %"
    description="RFM %"
    :chartOptions="backgroundColor"
  >
    <template slot="header">
      <h5 class="card-title pb-5p">{{ i18nValues["rfm%"] }}</h5>
    </template>
    <template slot="footer">
      <div class="legend" style="min-height: 230px;padding-bottom: 10px">
        <div v-for="(label, index) in pieChart.labels" :key="label">
          <i class="fa fa-circle" :style="{color:rfmMap[index].color}"></i>
          {{ label }}: {{ pieChart.series[index] }}
        </div>
        
      </div>
    </template>
  </chart-card>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/dashboard/index";
import BarChart from "@/components/dashboard/BarChart";
export default {
  name: "ProfilesSection",
  created: function() {
    this.obtainBackgroundColors();
  },
  props: {
    rfmMap: Array,
    pieChart: Object,
  },
  components: {
    BarChart,
    ChartCard,
  },
  methods: {
    obtainBackgroundColors() {
      for (let i = 0; i < this.rfmMap.length; i++) {
        this.backgroundColor.push(this.rfmMap[i].color);
      }
    }
  },
  data() {
    return {
      backgroundColor: [],
    };
  },
};
</script>
<style scoped>
.align-end {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
}
.pb-5p {
  padding-bottom: 5px;
}
</style>
